import { COPY } from "../content/copy";

const Group = ({ hidden }) => (
    <div className="marquee-group" aria-hidden={hidden || undefined}>
        {COPY.marquee.map((w) => (
            <span className="marquee-item" key={w}>
                <span className="marquee-word">{w}</span>
                <span className="marquee-tri">▲</span>
            </span>
        ))}
    </div>
);

export default function MarqueeBand() {
    return (
        <section className="marquee-band" data-testid="marquee-band" aria-label="Il patto in sei parole">
            <div className="marquee-track">
                <Group />
                <Group hidden />
            </div>
        </section>
    );
}
